import type { FrameInferenceResult, RapidBoxPromptData } from "@rapid/types/inference";

export type ExampleData = Array<{
    isVideo: boolean;
    filePath: string;
    resizedFilePath?: string | null;
    isSharable: boolean;
    authenticatedData?: { url: string; resizedUrl?: string };
}>;

export enum BuildInferenceType {
    SAM3 = "sam3",
    OWLV2 = "owlv2",
    RAPID = "rapid"
}

export type BuildMetadataInferenceTypes = Record<string, BuildInferenceType>;

export type BuildMetadata = {
    inferenceTypes: BuildMetadataInferenceTypes;
    hasBoxPrompts?: boolean;
    promptNames?: Record<string, string>;
};

export type RapidSetupPayloadRef = {
    path: string;
    contentEncoding?: "gzip";
    contentType?: string;
    sizeBytes?: number;
    expiresAt?: string;
};

export type CreateRapidWorkflowProps = {
    workspaceId?: string;
    task: string | null;
    groundTruthData?: FrameInferenceResult[];
    predictionDatasetData?: FrameInferenceResult[];
    predictionReviewData?: FrameInferenceResult[];
    instantPromptData?: RapidBoxPromptData[];
    setupPayloadRef?: RapidSetupPayloadRef;
    isSync?: boolean;
    exampleData: ExampleData;
    buildMetadata: BuildMetadata;
    name?: string;
};
